import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/core/common/redux/RemoteRecord';
import { getPlaceKanbanOrder } from 'b2b-apps/core/kanban';
import { PlaceKanbanOrderDataType } from 'b2b-common/core/kanban';

export type UsePlaceKanbanOrderDataReturnType = RemoteRecord<PlaceKanbanOrderDataType>;
export const usePlaceKanbanOrderData = (): UsePlaceKanbanOrderDataReturnType => useSelector(getPlaceKanbanOrder);
